module.exports = __webpack_public_path__ + "img/img_skin_1_1.de1f194c.png";